import { render, staticRenderFns } from "./HotGoods.vue?vue&type=template&id=15bfff7b&scoped=true&"
import script from "./HotGoods.vue?vue&type=script&lang=js&"
export * from "./HotGoods.vue?vue&type=script&lang=js&"
import style0 from "./HotGoods.vue?vue&type=style&index=0&id=15bfff7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bfff7b",
  null
  
)

export default component.exports